module.exports = __webpack_public_path__ + "static/media/sitting-stationary.22d0ec07.svg";